<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page12">
</a><a id="page13">
</a><div class="chapterHead"><a id="page13">
</a><h2 class="chapterTitle1"><a id="page13"><span class="xrefInternal"></span></a><a href="#/paulwasnotachristian_toc#fm_01"><span class="bold"><em class="italic">Note to the Reader</em></span></a></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText">All translations of Paul’s letters are mine based on the Nestle-Aland twenty-seventh edition Greek New Testament, unless otherwise indicated. Translations from other parts of the Bible are from the New Revised Standard Version (NRSV), unless otherwise indicated.</p>
<p class="para">I have tried to avoid the use of technical terms, but there are times when they were useful. In light of this I have provided a brief glossary at the end of the book.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// paulwasnotachristian_fm01.vue?4606fb56